import React from 'react';

export type AdminButtonVariant = 'default' | 'primary' | 'danger' | 'ghost';

export interface AdminButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: AdminButtonVariant;
}

export interface AdminIconButtonProps
  extends Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'aria-label'> {
  'aria-label': string;
  active?: boolean;
}

export const AdminButton = React.forwardRef<HTMLButtonElement, AdminButtonProps>(
  ({ variant = 'default', className = '', type = 'button', ...props }, ref) => (
    <button
      ref={ref}
      type={type}
      className={`admin-button admin-button--${variant} ${className}`.trim()}
      {...props}
    />
  )
);

AdminButton.displayName = 'AdminButton';

export const AdminIconButton = React.forwardRef<HTMLButtonElement, AdminIconButtonProps>(
  ({ active = false, className = '', type = 'button', ...props }, ref) => (
    <button
      ref={ref}
      type={type}
      className={`admin-icon-button${active ? ' admin-icon-button--active' : ''} ${className}`.trim()}
      {...props}
    />
  )
);

AdminIconButton.displayName = 'AdminIconButton';
